<div fxLayout="row" fxLayoutGap="4px" fxLayoutAlign="start center">
  <ng-container *ngIf="isSisal">
    <mat-icon class="icon-16" fxFlex="16px" [class.bottom-arrow]="coloredYarnSet.isBottomPosition()" svgIcon="arrow"></mat-icon>
  </ng-container>
  <div [fxFlex]="isSisal ? 'calc(100% - 20px)' : '100%'">
    <app-color-list-preview
      #colorListPreview
      [colorList]="getColorList(coloredYarnSet.coloredYarnSet)"
      [positionOfDialog]="dialogPosition"
      [creelMapping]="creelMapping ?? null"
      [showBoxShadow]="false"
    >
    </app-color-list-preview>
  </div>
</div>
